<template>
    <div class="c-comparison">
        <div class="c-comparison__header">
            <div class="c-comparison-header">
                <div class="c-comparison-header__title">
                    <h1 class="c-title">
                        {{ $t("Comparison.Page.title") }}
                    </h1>
                </div>

                <div class="c-comparison-header__actions" v-if="isInitialized && items.length">
                    <!-- Commented because maybe in the future we will want it -->
                    <!-- <button type="button" class="c-btn is-share" @click="share">-->
                    <!--    <i class="ico ico-share" aria-hidden="true"></i>-->
                    <!--    {{ $t('Comparison.Page.share') }}-->
                    <!-- </button>-->
                    <button type="button" class="c-btn is-delete" @click="removeAll">
                        <i class="ico ico-x-circle" aria-hidden="true"></i>
                        {{ $t("Comparison.Page.deleteAll") }}
                    </button>
                </div>
            </div>
        </div>

        <div
            class="c-comparison__navigation"
            v-if="isInitialized && items.length && Object.keys(types).length > 1"
        >
            <button
                v-for="(type, index) in types"
                type="button"
                class="c-btn"
                :class="{ 'is-active': activeGroup == type.id }"
                :key="index"
                @click="changeType(type.id)"
            >
                {{ type.name }} <span class="c-badge">{{ type.count }}</span>
            </button>
        </div>

        <div class="c-comparison__table">
            <div class="c-msg c-msg--info is-flash" v-if="isInitialized && !items.length">
                {{ $t("Comparison.Table.empty") }}
            </div>

            <div
                class="c-comparison-table js-comparison-table"
                v-if="isInitialized && items.length"
            >
                <div
                    class="c-comparison-table__header js-comparison-table-header scroll-together"
                    @scroll="syncScrolling"
                    :class="{ 'is-sticky': isSticky }"
                    name="comparison-table"
                >
                    <div class="c-comparison-table__column is-aside">
                        <div class="c-comparison-group__item">
                            <span class="is-key">{{ $t("Comparison.Table.product") }}</span>
                        </div>
                    </div>

                    <div
                        class="c-comparison-table__column"
                        v-for="item in filteredItems"
                        :key="item.id"
                    >
                        <ComparisonProduct :item="item" @remove="removeItem" />
                    </div>
                </div>

                <div
                    class="c-comparison-table__content scroll-together"
                    @scroll="syncScrolling"
                    name="comparison-table"
                >
                    <div class="c-comparison-table__column is-aside">
                        <div class="c-comparison-group">
                            <div
                                class="c-comparison-group__item js-comparison-group-item"
                                @mouseover="enableHighlighting(id)"
                                @mouseout="disableHighlighting(id)"
                            >
                                <span class="is-key"> Hodnotenie </span>
                            </div>
                        </div>

                        <ComparisonGroup
                            v-for="(group, groupId) in filteredProperties"
                            :key="groupId"
                            :group="group"
                            :groupId="groupId"
                        />
                    </div>

                    <div
                        class="c-comparison-table__column"
                        v-for="item in filteredItems"
                        :key="item.id"
                    >
                        <div
                            class="c-comparison-group__item js-comparison-group-item"
                            @mouseover="enableHighlighting(id)"
                            @mouseout="disableHighlighting(id)"
                        >
                            <span class="is-key"> Hodnotenie </span>
                            <span class="is-value">
                                <div class="c-rating">
                                    <div class="c-rating__stars">
                                        <div class="c-stars">
                                            <div class="c-stars__empty">
                                                <i
                                                    v-for="n in 5"
                                                    :key="n"
                                                    class="ico ico-star"
                                                    aria-hidden="true"
                                                ></i>
                                            </div>

                                            <div
                                                class="c-stars__full"
                                                :style="{
                                                    width: `${item.rating_avg || 0}%`,
                                                }"
                                            >
                                                <i
                                                    v-for="n in 5"
                                                    :key="n"
                                                    class="ico ico-star"
                                                    aria-hidden="true"
                                                ></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="c-rating__count" v-if="item.rating_sum">
                                        ({{ item.rating_sum }})
                                    </div>
                                </div>
                            </span>
                        </div>
                        <ComparisonGroup
                            v-for="(group, groupId) in filteredProperties"
                            :key="groupId"
                            :item-id="item.id"
                            :group="group"
                            :groupId="groupId"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import client from "./../../../../vendor/rshop/frontend/assets/js/common/client";
import { CancelToken } from "axios";
import { initTippy } from "../../functions/tippy";
import { calculateHeaderSize } from "../../functions/window";

const lang = document.querySelector("html").getAttribute("lang");
let locale;

import(`Locale/${lang}`).then((module) => {
    locale = module;
});

export default {
    components: {
        ComparisonProduct: () => import("./ComparisonProduct"),
        ComparisonGroup: () => import("./ComparisonGroup"),
    },
    data() {
        return {
            isInitialized: false,
            isSticky: false,
            types: [],
            items: [],
            properties: [],
            fetchCancelToken: null,
            fetchingProducts: true,
            activeGroup: 0,
        };
    },
    computed: {
        filteredItems() {
            return this.items.filter(
                (item) => (item.product_type_id ? item.product_type_id : 0) == this.activeGroup
            );
        },
        filteredProperties() {
            return this.properties.filter((group) => group.productTypeId == this.activeGroup);
        },
    },
    created() {
        this.fetchComparison();

        document.addEventListener("scroll", this.checkStickiness);
    },
    watch: {
        items() {
            Event.dispatch("Comparison.countUpdated", {
                count: this.items.length,
            });
        },
    },
    methods: {
        syncScrolling() {
            const scrollElements = document.querySelectorAll(".scroll-together");

            scrollElements.forEach((element) => {
                element.addEventListener("scroll", function () {
                    const scrollLeft = element.scrollLeft;
                    scrollElements.forEach((el) => {
                        if (el !== element) {
                            el.scrollLeft = scrollLeft;
                        }
                    });
                });
            });
        },
        cancelFetchComparison() {
            if (this.fetchCancelToken) {
                this.fetchCancelToken.cancel();
            }

            this.fetchCancelToken = CancelToken.source();
        },
        fetchComparison() {
            this.cancelFetchComparison();
            this.fetchProducts();
        },
        fetchProducts() {
            this.fetchingProducts = true;

            client
                .get("/comparison-fetch-products", {
                    cancelToken: this.fetchCancelToken.token,
                })
                .then((response) => {
                    if (!response.data.status) {
                        return;
                    }
                    this.types = Object.values(response.data.data.types);
                    this.items = Object.values(response.data.data.items);
                    this.properties = Object.values(response.data.data.properties);
                    this.activeGroup = this.types[0].id;

                    Event.dispatch("Cart.fetchedComparisonProducts", {
                        response: response.data,
                    });

                    this.isInitialized = true;

                    setTimeout(() => {
                        initTippy();
                    }, 1000);
                })
                .catch((error) => {})
                .then(() => {
                    this.fetchingProducts = false;
                });
        },
        checkStickiness() {
            calculateHeaderSize();

            const windowOffset = window.pageYOffset,
                tableHeaderHeight = document.querySelector(".js-comparison-table-header")
                    ? document.querySelector(".js-comparison-table-header").offsetHeight
                    : 0,
                tableOffset = document.querySelector(".js-comparison-table")
                    ? document.querySelector(".js-comparison-table").offsetTop
                    : 100000,
                headerHeight =
                    parseInt(
                        getComputedStyle(document.documentElement).getPropertyValue(
                            "--header-height"
                        )
                    ) || 0;

            this.isSticky = windowOffset > tableOffset + tableHeaderHeight + headerHeight;
        },
        removeItem(productId) {
            let itemIndex = -1;

            // find item
            const item = this.items.find((item, index) => {
                if (item.id === productId) {
                    itemIndex = index;

                    return true;
                }

                return false;
            });

            if (itemIndex === -1) {
                return false;
            }

            // remove item
            window.Eshop.confirm(
                locale.Swal.RemoveComparison.title,
                {
                    denyButtonText: locale.Swal.RemoveComparison.deny,
                    confirmButtonText: locale.Swal.RemoveComparison.confirm,
                },
                () => {
                    document.querySelector(".swal2-confirm").classList.add("is-loading");

                    return client.post(`/remove-comparison-item/${productId}`).then((response) => {
                        window.Event.dispatch("Comparison.removedProduct", {
                            response: response.data,
                            product: item,
                        });
                    });
                },
                (result) => {
                    if (result.isConfirmed) {
                        Eshop.alert(`"${item.name}" ${locale.Comparison.Event.itemRemoved}`);

                        this.items.splice(itemIndex, 1);
                        this.fetchComparison();
                    }
                }
            );
        },
        removeAll() {
            window.Eshop.confirm(
                locale.Swal.RemoveComparisonAll.title,
                {
                    denyButtonText: locale.Swal.RemoveComparisonAll.deny,
                    confirmButtonText: locale.Swal.RemoveComparisonAll.confirm,
                },
                () => {
                    document.querySelector(".swal2-confirm").classList.add("is-loading");

                    return client.post(`/remove-comparison-items`).then((response) => {
                        window.Event.dispatch("Comparison.removedProducts", {
                            response: response.data,
                        });
                    });
                },
                (result) => {
                    if (result.isConfirmed) {
                        Eshop.alert(`${locale.Comparison.Event.itemsRemoved}`);

                        this.items = [];
                        this.fetchComparison();
                    }
                }
            );
        },
        share() {
            const url = $("#recommendation-compare-url").attr("value");
            let urlAppend = "";

            this.items.forEach((item, index) => (urlAppend += `id[${index}]=${item.id}&`));

            $("#comparison-share").modal("show");
            $("#recommendation-compare-url").attr("value", `${url}?${urlAppend}`);
        },
        changeType(typeId) {
            this.activeGroup = typeId;

            setTimeout(() => {
                initTippy();
            }, 1000);
        },
    },
};
</script>
